import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.nav.user');
import { OnInit, DoCheck, ChangeDetectorRef, OnChanges } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'wiz-component-nav-user',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.nav.user/view.scss */
/* src/app/component.nav.user/view.scss: no such file or directory */`],
})
export class ComponentNavUserComponent implements OnInit, OnChanges {
    constructor(@Inject( Service)         public service: Service,@Inject( ActivatedRoute)         private route: ActivatedRoute,@Inject( Router)         private router: Router,@Inject( ChangeDetectorRef)         private cdr: ChangeDetectorRef) { }

    public org_menus = [
        { label: '정보', path: 'info', icon: 'Info' },
        { label: '이슈', path: 'issue', icon: 'Ticket' },
        { label: '문서함', path: 'document', icon: 'FolderOpen' }
    ]
    public showOrgSubmenu = false;
    // public selectedOrganization = "주식회사 시즌";
    public selectedOrganization: any;

    public userMenu = [
        { id: 'dashboard', label: '대시보드', icon: 'LayoutDashboard', path: '/dashboard', ctf: false },
        { id: 'org-status', label: '기관현황', icon: 'Building2', path: '/institutes', ctf: false },
        {
            id: 'notice',
            label: '공지사항',
            icon: 'Bell',
            children: [
                { id: 'alerts', label: '알림', icon: 'Bell', path: '/notice/alert' },
                { id: 'usage-notice', label: '이용공지', icon: 'FileText', path: '/notice/use' }
            ],
            ctf: true
        },
        { id: 'mypage', label: '마이페이지', icon: 'User', path: '/mypage', ctf: false }
    ];
    public expandedMenus: Record<string, boolean> = {};

    public session: any;

    public insID: any;
    public mode: any;

    private navSub?: any;

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow();
        this.session = this.service.auth.session;

        // ✅ URL 변경 반응
        this.navSub = this.router.events
            .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
            .subscribe(() => {
                // 비동기지만 기다릴 필요는 없음
                this.updateFromUrl();
            });

        // 초기 실행
        await this.updateFromUrl();
        await this.service.render();
    }

    public ngOnDestroy() {
        this.navSub?.unsubscribe();
    }

    private async updateFromUrl() {
        const url = this.router.url;

        if (url.includes('/institutes/')) {
            const segments = url.split('/').filter(Boolean);
            const idx = segments.indexOf('institutes');
            const insID = segments[idx + 1] || null;
            const mode = segments[idx + 2] || null;

            const changed = this.insID !== insID || this.mode !== mode;
            this.insID = insID;
            this.mode = mode;
            if (changed) {
                // 🔥 서버에 insID로 기관 정보 요청
                const { code, data } = await wiz.call("load", { insID: this.insID });
                if (code === 200 && data) {
                    this.selectedOrganization = data.name;
                    this.showOrgSubmenu = true;
                    await this.service.render();
                } else {
                    this.selectedOrganization = null;
                    this.showOrgSubmenu = false;
                    await this.service.alert.error("기관 정보를 불러올 수 없습니다.");
                }
                this.cdr.detectChanges();
            }
        } else {
            this.insID = null;
            this.mode = null;
            this.selectedOrganization = null;
            this.showOrgSubmenu = false;
            await this.service.render();
        }
        await this.service.render();
    }

    public toggleMenu(menuId: string) {
        this.expandedMenus = {
            ...this.expandedMenus,
            [menuId]: !this.expandedMenus[menuId]
        };
    }

    public isActive(link: string) {
        return location.pathname.indexOf(link) === 0
    }

    // lucide 이름 → Tabler 아이콘 클래스 매핑
    public getIconClass(iconName: string) {
        const map = {
            LayoutDashboard: 'fa-solid fa-gauge',
            Building2: 'fa-solid fa-building',
            Bell: 'fa-solid fa-bell',
            FileText: 'fa-solid fa-file-lines',
            User: 'fa-solid fa-user',
            Users: 'fa-solid fa-users',
            TicketCheck: 'fa-solid fa-ticket',
            Network: 'fa-solid fa-network-wired',
            Megaphone: 'fa-solid fa-bullhorn',
            Zap: 'fa-solid fa-bolt',
            Cloud: 'fa-solid fa-cloud',
            Activity: 'fa-solid fa-chart-line',
            BookOpen: 'fa-solid fa-book-open',
            Info: 'fa-solid fa-circle-info',
            Ticket: 'fa-solid fa-ticket',
            FolderOpen: 'fa-solid fa-folder-open',
            Settings: 'fa-solid fa-gear',
            LogOut: 'fa-solid fa-right-from-bracket',
            ChevronDown: 'fa-solid fa-chevron-down',
            Circle: 'fa-solid fa-circle'
        };
        return map[iconName] || 'fa-solid fa-circle';
    }
}

export default ComponentNavUserComponent;